import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { SERVER_URL } from 'src/app/config';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  if (req.url.startsWith(SERVER_URL) && !req.url.startsWith('https://ui2beehomecms')) {
    req = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + auth.getToken()
      }
    });
  }
  return next(req);
};
